import {loadJS} from "./helper";

class TurnstileContainer extends HTMLElement {
    async connectedCallback() {
        const turnstileCallback = () => {
            const container = this;
            turnstile.render(this, {
                callback: function (token) {
                    const turnstileSuccessCallbackEvent = new CustomEvent("turnstile.success", {detail: {token: token}});
                    container.dispatchEvent(turnstileSuccessCallbackEvent);
                }
            })
        }

        loadJS(this, this.dataset.url, true, turnstileCallback)
    }
}

customElements.define('turnstile-container', TurnstileContainer);
